import React from 'react';

import api                                 from '../../../../../api';
import values                              from '../../../../../values';
import FactorsNeedPay2CompanyScreenContext from '../../../../../context/FactorsNeedPay2CompanyScreen.context';

import FactorsNeedPay2CompanyScreen from '..';

import { useQuery } from 'react-query';

import { TModal                    } from '../../../../../types/common.type';
import { FinancialCompanyNamespace } from '../../../../../types/financiallCompany.namespace';
import {companyGetFinancialReportDrivers} from "../../../../../values/useQueryKeys";
import {getFinancialReportDrivers} from "../../../../../api/method.get/company";
import utils from "../../../../../utils";

const CompanyFinancialReportContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const today: Date = new Date();

  const year : number = today.getFullYear();
  const month: string = String(today.getMonth() + 1).padStart(2, '0');
  const day  : string = String(today.getDate ()    ).padStart(2, '0');

  const formattedDate: string = `${year}-${month}-${day}`;

  const [request, setRequest] = React.useState<string>(formattedDate)
  const [showModal, setShowModal] = React.useState<TModal>('NONE');


  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getFianncialReport = useQuery(
    [values.useQueryKeys?.companyGetFinancialReportDrivers, request],
    () => api.get.company.getFinancialReportDrivers(request)
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  // async function payCompanyFactors(): Promise<void> {
  //   setIsLoading(true);
  //   // await api.get.company.payFactorsIsNeedPay2Company();
  //   // getPaginatedFactors.refetch();
  //   // getAllFactors.refetch();
  //   setShowModal('NONE');
  //   setIsLoading(false);
  // }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <FactorsNeedPay2CompanyScreenContext.Provider value={{
      request  ,
      showModal,
      setRequest  ,
      setShowModal,
      reFetch: getFianncialReport.refetch,
    }}>
      <FactorsNeedPay2CompanyScreen
        resultData={getFianncialReport}
      />
    </FactorsNeedPay2CompanyScreenContext.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

}

export default CompanyFinancialReportContainer;
